// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__z_CdH","title":"BackImages_title__249GO","images":"BackImages_images__3X5_i"};